import VideoEntry from './video-entry';
import PropTypes from 'prop-types';

const VideoList = ({ selectedVideos = [], onToggleSelection, onDeleteVideo, videos, onCopyVideo }) => (
  <>
    {videos.map((video) => {
      return (
        <li key={video.id} className="video-library--entry">
          <VideoEntry
            video={video}
            deleteVideoEntry={onDeleteVideo}
            isSelected={selectedVideos.includes(video.id)}
            onToggleSelection={() => onToggleSelection(video.id)}
            onCopyVideo={onCopyVideo}
          />
        </li>
      );
    })}
  </>
);

VideoList.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedVideos: PropTypes.arrayOf(PropTypes.string),
  onToggleSelection: PropTypes.func.isRequired,
  onDeleteVideo: PropTypes.func.isRequired,
  onCopyVideo: PropTypes.func,
};

export default VideoList;
